import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addVoid from '../parts/addVoid'

k.loadSprite('pot', 'sprites/pot.png', {
  sliceX: 2,
  anims: {
    default: 0,
    added: 1
  }
})

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(6)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addVoid(250)

  const grass = k.add([
    k.sprite('grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const pot = grass.add([
    k.sprite('pot'),
    k.pos(100, 0),
    k.area(),
    k.anchor('bot'),
    'pot'
  ])

  const grassFinal = k.add([
    k.sprite('small-grass'),
    k.pos(240, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const door = grassFinal.add([
    k.sprite('door'),
    k.pos(75, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let placedPlant = false
  let atPot = false

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    if (placedPlant) tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onCollide('pot', () => {
    atPot = true
    if (!placedPlant) tooltipE.hidden = false
  })
  robot.onCollideEnd('pot', () => {
    atPot = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen && placedPlant) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('seven')
    } else if (atPot && !placedPlant) {
      placedPlant = true
      pot.play('added')
      robot.sprite = 'robotPlantless'
    }
  })
}
